import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../hooks/useTheme';

export default function ThemeToggle({ className = '' }) {
  const { isDark, toggle } = useTheme();
  return (
    <button type="button" onClick={toggle} className={`gx-theme-btn ${className}`} title={isDark ? 'Switch to light mode' : 'Switch to dark mode'} aria-label="Toggle theme" data-testid="theme-toggle">
      {isDark ? <Moon key="moon" className="gx-theme-ic" /> : <Sun key="sun" className="gx-theme-ic" />}
    </button>
  );
}
